module.exports = __webpack_public_path__ + "img/Bob.a4be4bda.jpg";